<template>
    <div id="create-brand-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Brand</h1>
                <BrandForm @formSubmitted="createBrand" />
            </section>
        </div>
    </div>
</template>

<script>
import BrandForm from '@/components/forms/BrandForm.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/brands/create'
import axios from 'axios'

export default {
    name: 'BrandsCreate',
    components: {
        BrandForm
    },
    data: function() {
        return {

        }
    },
    methods: {
        createBrand(data) {
            axios.post(endpoint, data)
                  .then(response => {
                      console.log(response)
                      alert('Brand created successfully')
                      this.$router.push('/brands')
                  })
                  .catch(error => {
                      console.log(error.response)
                      if (error.response && error.response.data?.data) {
                          alert(error.response.data.data)
                      }
                      else {
                          alert('Error occurred!')
                          console.log(error)
                      }
                  })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
